import { useState, useEffect } from 'react';

export const useTheme = () => {
  // Inicjalizacja stanu na podstawie localStorage
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('theme') || 'base';
  });

  useEffect(() => {
    // Aktualizacja klasy na body przy każdej zmianie stanu theme
    if (theme === 'dark') {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
    
    // Zapisanie wyboru w localStorage
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'base' ? 'dark' : 'base'));
  };

  return { theme, toggleTheme };
};